import styled from 'styled-components';

const Wrapper = styled.div`
  color: darkred;
  display: block;
  font-size: 14px;
  margin-bottom: 12px;
  text-align: center;
`;

type Props = {
  message: string;
};

export const ErrorMessage = ({ message }: Props) => <Wrapper>{message}</Wrapper>;
